module.exports = __webpack_public_path__ + "img/Camera&lens4.3807ebb1.png";